import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resumen-baja',
  templateUrl: './lista.component.html'
})

export class BajaComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

  ngOnInit() {
    document.getElementById("tipo").click();
  }
}
